import _clamp from 'lodash/clamp';
import { TComment } from 'shared/models';

interface ICommentImage {
  width: string;
  height: string;
  src: string;
  alt: string;
}

const IMAGE_MIN_DESIGN_WIDTH = 96;

export const useCommentImage = (comment: TComment): ICommentImage | null => {
  const { imageList } = comment;
  if (!imageList?.length) {
    return null;
  }

  const image = imageList[0];
  const { width, height, url } = image;
  const aspectRatio = _clamp(width / height, 3 / 4, 4 / 3);

  return {
    width: `${(Math.max(aspectRatio, 1) * IMAGE_MIN_DESIGN_WIDTH * 16) / 375}rem`,
    height: `${(Math.max(1 / aspectRatio, 1) * IMAGE_MIN_DESIGN_WIDTH * 16) / 375}rem`,
    src: url,
    // TODO alt
    alt: '',
  };
};
